import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/goalsCard.css';
import {getText} from '../../../../../../helpers/localization';
import Button from '../components/button';

const mapStateToProps = (state, ownProps) => {
    return {
        events: state.vpp.events,
        selectedEventId: state.vpp.selectedEventId,
        selectedEventIndex: state.vpp.selectedEventIndex,
        openBetsList: state.vpp.openBetsList,
        selectedChip: state.vpp.selectedChip
    };
};

class ResultCard extends Component {
    constructor(props) {
        super(props);

        let store = props.store;
        let storeData = store.getState();

        this.state = {
            events: storeData.vpp.events,
            selectedEventId: storeData.vpp.selectedEventId,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            openBetsList: storeData.vpp.openBetsList,
            selectedChip: storeData.vpp.selectedChip,
            isFirstToScoreSelected: true
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        this.setState({
            events: storeData.vpp.events,
            selectedEventId: storeData.vpp.selectedEventId,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            openBetsList: storeData.vpp.openBetsList,
            selectedChip: storeData.vpp.selectedChip
        });
    }

    render() {
        let selectedEvent = this.state.events[this.state.selectedEventIndex];
        let overUnder25 = selectedEvent.markets.filter(market => market.code === 15);
        let totalGoals = selectedEvent.markets.filter(market => market.code === 11);
        let firstTeamToScore = selectedEvent.markets.filter(market => market.code === 37);
        let lastTeamToScore = selectedEvent.markets.filter(market => market.code === 38);

        let firstLastButtonsUI;
        if (this.state.isFirstToScoreSelected) {
            firstLastButtonsUI = [
                <Button key='1' wrapperClass={style.innerContainer} customButtonClass={style.buttonStyle}
                        store={this.props.store} market={firstTeamToScore.filter(m => m.num === 0)[0]}
                        topText={getText(selectedEvent.teamOne, this.props.store)}/>,
                <Button key='2' wrapperClass={style.innerContainer} customButtonClass={style.buttonStyle}
                        store={this.props.store} market={firstTeamToScore.filter(m => m.num === 2)[0]}
                        topText={getText(selectedEvent.teamTwo, this.props.store)}/>
            ];
        } else {
            firstLastButtonsUI = [
                <Button key='1' wrapperClass={style.innerContainer} customButtonClass={style.buttonStyle}
                        store={this.props.store} market={lastTeamToScore.filter(m => m.num === 0)[0]}
                        topText={getText(selectedEvent.teamOne, this.props.store)}/>,
                <Button key='2' wrapperClass={style.innerContainer} customButtonClass={style.buttonStyle}
                        store={this.props.store} market={lastTeamToScore.filter(m => m.num === 2)[0]}
                        topText={getText(selectedEvent.teamTwo, this.props.store)}/>
            ];
        }

        let toogleStyle = !this.state.isFirstToScoreSelected
            ? style.toggle + ' ' + style.checked
            : style.toggle;

        return (<div className={style.goalsCardContainer}>
            <div className={style.titleContainer}>
                <div className={style.topBar}>
                    <div className={style.eventTitle}>{selectedEvent.title}</div>
                    <div className={style.eventPlace}>{selectedEvent.stadium}</div>
                </div>
            </div>
            <div className={style.marketContainer}>
                <div className={style.topBar}>
                    <div className={style.marketTitle}>{getText('TOTAL_GOALS', this.props.store)}</div>
                </div>
                <div className={style.container}>
                    <Button wrapperClass={style.innerContainer} customButtonClass={style.buttonStyle}
                            store={this.props.store} market={overUnder25.filter(m => m.num === 1)[0]}
                            topText={getText(overUnder25.filter(m => m.num === 1)[0].selection, this.props.store)}/>
                    <Button wrapperClass={style.innerContainer} customButtonClass={style.buttonStyle}
                            store={this.props.store} market={overUnder25.filter(m => m.num === 0)[0]}
                            topText={getText(overUnder25.filter(m => m.num === 0)[0].selection, this.props.store)}/>
                </div>
                <div className={style.container}>
                    <Button wrapperClass={style.innerContainer} customButtonClass={style.buttonStyle}
                            store={this.props.store} market={totalGoals.filter(m => m.num === 0)[0]}
                            topText={totalGoals.filter(m => m.num === 0)[0].selection}/>
                    <Button wrapperClass={style.innerContainer} customButtonClass={style.buttonStyle}
                            store={this.props.store} market={totalGoals.filter(m => m.num === 1)[0]}
                            topText={totalGoals.filter(m => m.num === 1)[0].selection}/>
                    <Button wrapperClass={style.innerContainer} customButtonClass={style.buttonStyle}
                            store={this.props.store} market={totalGoals.filter(m => m.num === 2)[0]}
                            topText={totalGoals.filter(m => m.num === 2)[0].selection}/>
                    <Button wrapperClass={style.innerContainer} customButtonClass={style.buttonStyle}
                            store={this.props.store} market={totalGoals.filter(m => m.num === 3)[0]}
                            topText={totalGoals.filter(m => m.num === 3)[0].selection}/>
                    <Button wrapperClass={style.innerContainer} customButtonClass={style.buttonStyle}
                            store={this.props.store} market={totalGoals.filter(m => m.num === 4)[0]}
                            topText={totalGoals.filter(m => m.num === 4)[0].selection}/>
                </div>
            </div>
            <div className={style.marketContainer}>
                <div className={style.topBar}>
                    <div className={style.marketTitle}>{getText('FIRST_LAST_TO_SCORE', this.props.store)}</div>
                </div>
                <div className={style.container}>
                    {firstLastButtonsUI}
                    <div className={style.innerContainer}>
                        <div className={toogleStyle}>
                            <div className={style.firstToggleOption}
                                 onClick={() => this.setState({isFirstToScoreSelected: true})}>{getText('FIRST', this.props.store)}</div>
                            <div className={style.secondToggleOption}
                                 onClick={() => this.setState({isFirstToScoreSelected: false})}>{getText('LAST', this.props.store)}</div>
                            <div className={style.slider}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
    }
}

export default connect(mapStateToProps)(ResultCard);


// WEBPACK FOOTER //
// ./src/ui-modules/simplified/mobile/modules/football/containers/goalsCard.js